import { Component, Input } from '@angular/core';
import { L10nTranslationService } from 'angular-l10n';

@Component({
  selector: 'samplicity-field-label',
  templateUrl: './field-label.component.html',
  styleUrls: ['./field-label.component.scss'],
})
export class FieldLabelComponent  {
  constructor(private translationService: L10nTranslationService){};

  @Input() inputId: string;
  @Input() label: string | object[];
  @Input() labelParameters: object;
  @Input() labelTranslated = true;
  @Input() required = false;
  @Input() colon = true;
  @Input() showAsHeading = false;

  get isDto(): boolean {
    return Array.isArray(this.label) && this.label[0] instanceof Object;
  }

  get lang (): string {
    return this.translationService.getLocale().language
  }
}
